import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { IRootState } from '../redux/rootReducer';

const ProtectedRoutes = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const token: string | null = localStorage.getItem('adminAccessToken');
    const permission = useSelector((state: IRootState) => state?.permissionsReducer?.data);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });
    }, [location]);

    // Handle redirection when user has a token but no permissions
    useEffect(() => {
        if (token && (!permission || Object.keys(permission).length === 0)) {
            navigate('/no-permission', { replace: true });
        }
    }, [token, permission, navigate]);

    if (!token) {
        return <Navigate to={`/login`} />;
    }

    return <Outlet />;
};

export default ProtectedRoutes;
